import { StockStatusObject } from "../types/ProductStock";
import stockIconOK from "../assets/icons/stock_ok.svg";
import stockIconWarn from "../assets/icons/stock_warn.svg";
import stockIconTime from "../assets/icons/stock_time.svg";
import stockIconEmpty from "../assets/icons/stock_empty.svg";
import stockIconUnknown from "../assets/icons/stock_unknown.svg";
import { ReactNode, useMemo, useRef } from "react";
import { useTooltip } from "./ToolTip";

export const StockIcon = ({
  stockStatus
}: {
  stockStatus: StockStatusObject;
}): ReactNode => {
  switch (stockStatus.icon) {
    case "ok":
    case "sampleOk":
      return (
        <img src={stockIconOK} className="icon" data-icon={"ok"} alt="✓" />
      );
    case "warn":
      return (
        <img src={stockIconWarn} className="icon" data-icon={"warn"} alt="⚠" />
      );
    case "time":
      return (
        <img src={stockIconTime} className="icon" data-icon={"time"} alt="⧖" />
      );
    case "empty":
    case "sampleEmpty":
      return (
        <img
          src={stockIconEmpty}
          className="icon"
          data-icon={"empty"}
          alt="x"
        />
      );
    default:
      return <img src={stockIconUnknown} className="icon" alt="?" />;
  }
};

const StockStatus = ({
  stockStatus,
  sku
}: {
  stockStatus: StockStatusObject;
  sku: string;
}) => {
  const tooltipParent = useRef<HTMLDivElement>(null);
  const tooltipContent = useMemo(
    () => (
      <>
        <div>
          <StockIcon stockStatus={stockStatus} /> {stockStatus.message}
        </div>
        {!!stockStatus.amount && (
          <div className={"mt-2"}>{stockStatus.amount}</div>
        )}
      </>
    ),
    [stockStatus]
  );
  useTooltip(tooltipParent, tooltipContent);
  return (
    <div className="stock-status" id={"stockIcon" + sku} ref={tooltipParent}>
      <StockIcon stockStatus={stockStatus} />
    </div>
  );
};

export default StockStatus;
